import { eachDayOfInterval, format } from 'date-fns';
import { defaultWorkingDays } from '../types';
const getDatesInRange = (startDate, endDate) => {
    return eachDayOfInterval({
        start: startDate,
        end: endDate,
    });
};
const getDayOfWeek = (date) => {
    return format(date, 'EEEE').toLowerCase();
};
/**
 * Returns a filter that returns true if date is on a working day
 * @param workingDays Days user works
 * @returns {(date: Date) => boolean} - filter that returns true if user is working on date's day of week
 */
const getNonWorkingDaysFilter = (workingDays) => {
    return (date) => {
        return workingDays[getDayOfWeek(date)];
    };
};
/**
 * Returns a filter that returns true if date is not in freeDays
 * @param freeDays list of free days
 * @returns {(date: Date) => boolean} - filter that returns true if date is not in freeDays
 */
const getFreeDaysFilter = (freeDays) => {
    return (date) => {
        return !freeDays.includes(format(date, 'yyyy-MM-dd'));
    };
};
export const getHolidayLength = (startDate, endDate, startInAfternoon, endInMorning, workingDays = defaultWorkingDays, freeDays = []) => {
    const freeDayFilter = getFreeDaysFilter(freeDays || []);
    const nonWorkingDaysFilter = getNonWorkingDaysFilter(workingDays);
    const days = getDatesInRange(startDate, endDate)
        .filter(nonWorkingDaysFilter)
        .filter((d) => !freeDays?.includes(format(d, 'yyyy-MM-dd')));
    const notStartingOnFreeDayOrNonWorkingDay = freeDayFilter(startDate) && nonWorkingDaysFilter(startDate);
    const notEndingOnFreeDayOrNonWorkingDay = freeDayFilter(endDate) && nonWorkingDaysFilter(endDate);
    const startInAfternoonSubtraction = notStartingOnFreeDayOrNonWorkingDay && startInAfternoon ? 0.5 : 0;
    const endInMorningSubtraction = notEndingOnFreeDayOrNonWorkingDay && endInMorning ? 0.5 : 0;
    return days.length - startInAfternoonSubtraction - endInMorningSubtraction;
};
